export enum GitHttpHeader {
  Type = 'x-storage-type',
  Id = 'x-storage-id',
  Branch = 'x-storage-branch',
  Path = 'x-storage-path',
  Commit = 'x-storage-commit',
  Location = 'x-storage-location',
  DbtId = 'x-storage-dbt-id',
}
